import React from 'react';
export const CFIconExternalLink = {
    alias: 'external-link',
    defaultTitle: 'External Link',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M19 18v-6a1 1 0 1 1 2 0v6c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h6a1 1 0 1 1 0 2H6c-.552 0-1 .449-1 1v12c0 .551.448 1 1 1h12c.552 0 1-.449 1-1ZM17.578 5.008 15.995 5A1 1 0 0 1 16 3h.005l3.997.02a1 1 0 0 1 .995.999L21 7.999a1 1 0 1 1-2 .002V6.415l-6.293 6.292a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6.285-6.285Z' }))),
};
